import React from "react";
import About from "../pages/About";
import "../styles/About.css";

export default function AboutLayout() {
  return (
    <main className="about-layout">
      <About />
    </main>
  );
}

